import { jsx as _jsx } from "react/jsx-runtime";
const overlayStyle = {
    position: "fixed",
    inset: 0,
    zIndex: 2147483645,
    pointerEvents: "none",
};
const rectStyle = (r) => ({
    position: "absolute",
    left: `${r.x}px`,
    top: `${r.y}px`,
    width: `${r.width}px`,
    height: `${r.height}px`,
    border: "2px dashed rgb(34 197 94)",
    background: "rgb(34 197 94 / 0.16)",
    borderRadius: "4px",
});
const dimensionsStyle = {
    position: "absolute",
    bottom: "calc(100% + 6px)",
    right: 0,
    padding: "2px 8px",
    borderRadius: "6px",
    background: "rgb(34 197 94)",
    color: "rgb(15 15 17)",
    fontSize: "11px",
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace",
    fontWeight: 700,
    whiteSpace: "nowrap",
};
export const DragAreaCanvas = ({ rect }) => {
    if (!rect)
        return null;
    return (_jsx("div", { style: overlayStyle, "aria-hidden": true, children: _jsx("div", { style: rectStyle(rect), children: _jsx("div", { style: dimensionsStyle, children: `${Math.round(rect.width)} × ${Math.round(rect.height)}` }) }) }));
};
//# sourceMappingURL=DragAreaCanvas.js.map